export default __webpack_public_path__ + "static/media/1_1_0.a897c26a.png";